import { gql } from '@apollo/client';

export const USE_BUSINESS_USER_VALIDATION_TOKEN = gql`
  mutation UseBusinessUserValidationToken($token: String!) {
    useBusinessUserValidationToken(token: $token) {
      id
    }
  }
`;
